import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import PropTypes from "prop-types";
import React from "react";

function ConfirmationDialog(props) {
  const { title, text, onAgree, open, onClose } = props;

  // Functions
  const handleAgree = () => {
    onAgree();
    onClose();
  };

  // Render
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{text}</DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button variant="text" onClick={onClose}>
          Disagree
        </Button>

        <Button variant="text" onClick={handleAgree}>
          Agree
        </Button>
      </DialogActions>
    </Dialog>
  );
}

ConfirmationDialog.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  onAgree: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ConfirmationDialog;
